import { ApiReducerKey } from 'constants/index';
import { combineReducers } from 'redux';

import list from './list';

export default combineReducers({
    [ApiReducerKey.LIST]: list,
});
